// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as CSS$MakerDs from "maker-ds/src/CSS.bs.mjs";
import * as Badge$MakerDs from "maker-ds/src/Badge.bs.mjs";
import * as Date$FeedSync from "./Date.bs.mjs";
import * as Query$MakerDs from "maker-ds/src/Query.bs.mjs";
import * as Location$FeedSync from "./Location.bs.mjs";
import * as ClientAPI$FeedSync from "./ClientAPI.bs.mjs";
import * as VerticalNav$MakerDs from "maker-ds/src/VerticalNav.bs.mjs";
import * as VerticalNavItem$MakerDs from "maker-ds/src/VerticalNavItem.bs.mjs";

function Navigation(Props) {
  var active = Props.active;
  return React.createElement(VerticalNav$MakerDs.make, {
              children: null
            }, React.createElement("div", {
                  className: CSS$MakerDs.prefix("ml-3 h-20")
                }, React.createElement("div", undefined, React.createElement("svg", {
                          className: CSS$MakerDs.prefix("h-6"),
                          fill: "none",
                          viewBox: "0 0 93 25",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, React.createElement("path", {
                              d: "M21.034 24.403V14.42c0-1.195-.261-2.048-.696-2.56-.434-.512-1.13-.768-2.086-.768-1.216 0-2.346.512-3.476 1.45v11.946h-4.26V14.42c0-1.195-.26-2.048-.694-2.56-.435-.512-1.13-.768-2.086-.768-1.391 0-2.521.427-3.477 1.365v11.946H0V8.02l4.259-.597v2.304c1.564-1.536 3.39-2.39 5.389-2.39 2.173 0 3.737.94 4.606 2.817 1.739-1.878 3.738-2.816 5.997-2.816 1.565 0 2.869.512 3.825 1.536s1.39 2.389 1.39 4.18v11.263h-4.432v.086zM38.33 22.526c-1.39 1.62-2.955 2.389-4.694 2.389-1.477 0-2.781-.427-3.737-1.366-.956-.853-1.478-1.962-1.478-3.327 0-3.67 3.303-5.632 9.909-5.888v-.426c0-1.11-.26-1.963-.782-2.39-.522-.511-1.391-.767-2.608-.767-1.651 0-3.477.597-5.562 1.792l-.87-3.328c2.086-1.28 4.433-1.962 7.04-1.962 2.521 0 4.346.512 5.476 1.62 1.13 1.11 1.652 2.816 1.565 5.12v5.888c0 .597.087 1.023.26 1.194.174.17.609.256 1.217.341l-.347 3.157c-2.869.342-4.607-.426-5.302-2.218h-.087v.17zm0-5.802c-2.086.256-3.564.597-4.433 1.109-.87.512-1.304 1.109-1.304 1.962 0 .683.261 1.195.696 1.536.434.427 1.043.597 1.825.597 1.217 0 2.347-.512 3.216-1.45v-3.754zM51.106 16.468v7.935h-4.258V.512L51.106 0v15.273h.087l5.998-7.338h5.128l-6.954 7.85 6.954 8.618H57.19l-6.085-7.935zM66.751 17.15c.087 1.365.609 2.475 1.478 3.242.87.854 2.086 1.195 3.564 1.195 1.825 0 3.563-.512 5.214-1.536l.522 3.498c-1.738.94-3.737 1.366-6.084 1.366-2.694 0-4.867-.768-6.519-2.304-1.651-1.536-2.433-3.669-2.433-6.229 0-2.645.782-4.863 2.433-6.484 1.652-1.622 3.738-2.475 6.258-2.475 2.173 0 3.911.597 5.128 1.792s1.825 2.816 1.825 4.864c0 1.023-.087 1.962-.347 2.73l-10.952.17v.171h-.087zm7.301-2.645v-.256c0-2.389-1.043-3.584-3.216-3.584-1.13 0-1.999.342-2.78 1.11a4.649 4.649 0 00-1.218 2.816l7.214-.086zM85.612 24.403h-4.259V8.106l4.26-.597v2.645c1.13-1.792 2.52-2.73 4.345-2.73 1.13 0 2.173.255 2.955.767l-.956 3.754c-.782-.426-1.564-.682-2.434-.682-1.564 0-2.955.938-3.998 2.9v10.24h.087z",
                              fill: "#212121"
                            }))), React.createElement("div", {
                      className: CSS$MakerDs.prefix("text-sm text-gray-500 mt-1")
                    }, "Feed")), React.createElement(VerticalNavItem$MakerDs.make, {
                  text: "Settings",
                  current: Caml_obj.equal(active, /* SettingsItem */0),
                  onClick: (function (param) {
                      Location$FeedSync.goTo(undefined, undefined, undefined, undefined, ["settings"]);
                    })
                }), React.createElement(VerticalNavItem$MakerDs.make, {
                  text: "Sync History",
                  current: Caml_obj.equal(active, /* MonitoringItem */1),
                  onClick: (function (param) {
                      Location$FeedSync.goTo(undefined, undefined, undefined, undefined, ["monitoring"]);
                    })
                }), React.createElement(VerticalNavItem$MakerDs.make, {
                  text: "Data Explorer",
                  current: Caml_obj.equal(active, /* DataItem */2),
                  onClick: (function (param) {
                      Location$FeedSync.goTo(undefined, undefined, undefined, undefined, ["data"]);
                    })
                }), React.createElement(VerticalNavItem$MakerDs.make, {
                  text: "Docs",
                  href: "https://docs.google.com/document/d/1EdqsrHAfqpbMMyIA9ZZdiQZugTKi579pjiNl8Xm4gmo/edit#heading=h.bkrrpc1e93bb",
                  target: "_blank"
                }), React.createElement(VerticalNavItem$MakerDs.make, {}), React.createElement(Query$MakerDs.make, {
                  hook: (function (param) {
                      return ClientAPI$FeedSync.useSnapshotHistory(undefined);
                    }),
                  render: (function (snapshots, param) {
                      var tracker = Belt_Array.getBy(snapshots, (function (tracker) {
                              return Caml_obj.equal(tracker._isLive, true);
                            }));
                      if (tracker !== undefined) {
                        return React.createElement("div", {
                                    className: CSS$MakerDs.prefix("mt-10 text-sm px-3")
                                  }, React.createElement("div", undefined, Date$FeedSync.formatDistanceToNow(new Date(tracker.startTime))), React.createElement("div", {
                                        className: CSS$MakerDs.prefix("text-xs text-gray-400")
                                      }, new Date(tracker.startTime).toLocaleString()), React.createElement("div", {
                                        className: CSS$MakerDs.prefix("mt-1")
                                      }, React.createElement(Badge$MakerDs.make, {
                                            text: "Current",
                                            color: /* Green */2
                                          })));
                      } else {
                        return null;
                      }
                    })
                }));
}

var make = Navigation;

export {
  make ,
}
/* react Not a pure module */
